[
    {
        "title": "[en]Home[/en][ja]ホーム[/ja]",
        "link": "/"
    },
    {
        "title": "[en]Database[/en][ja]データベース[/ja]",
        "link": "/database"
    },
    {
        "title": "[en]Forum[/en][ja]フォーラム[/ja]",
        "link": "/forum"
    }
]
